// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3ZRTH","itemTitle":"ClientEmergencyInfo_itemTitle__3iQVa","itemText":"ClientEmergencyInfo_itemText__39-mU"};